import { render } from "./CardLayout.vue?vue&type=template&id=988874a4"
import script from "./CardLayout.vue?vue&type=script&lang=js"
export * from "./CardLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__